// extracted by mini-css-extract-plugin
module.exports = {"spacer":"bg_bq"};